import React from "react";
import RissAppLogo from "../../../assets/rissapp-logo.png";
import { Tenant } from "../WebAccess";

type Props = {
  tenant?: Tenant;
};

export default function TenantLogo({ tenant }: Props) {
  return (
    <img
      src={tenant?.logoImageUrl || RissAppLogo}
      width={300}
      alt={tenant?.name || "Logo"}
    />
  );
}
